import React from "react";
import { Row, Col } from "../Grid";
import Accordion from "../Accordion";
import logo from "../../assets/logos/everlywell-logo.svg";
import * as Icons from "../Icons";
import SubscribeInput from "./SubscribeInput";
import FooterAccordionItem from "./FooterAccordionItem";
import { shopCategories, aboutCategories, moreCategories, legalLinks, socialLinks } from "./links";
import * as S from "./styles";
var content = {
  Shop: shopCategories,
  About: aboutCategories,
  More: moreCategories
};
export var Footer = function Footer(_ref) {
  var e = _ref.onSubscribeSubmit;
  return React.createElement(S.Footer, {
    "data-testid": "footer"
  }, React.createElement(S.Container, null, React.createElement(Row, {
    center: "xs",
    start: "md"
  }, React.createElement(S.MobileLogoWrapper, {
    xs: 12
  }, React.createElement(S.Logo, {
    alt: "Everlywell",
    src: logo,
    width: "107",
    height: "24"
  }))), React.createElement(Row, null, React.createElement(S.MobileAccordionCol, {
    xs: 12
  }, React.createElement(Accordion.Wrapper, null, Object.entries(content).map(function (e, t) {
    return React.createElement(FooterAccordionItem, {
      key: "link-section-" + t,
      heading: e[0],
      listOfLinkObjects: e[1],
      showBorderBottom: !0
    });
  }))), React.createElement(S.FlexCol, {
    xs: 12
  }, React.createElement(S.DesktopLogoWrapper, null, React.createElement(S.Logo, {
    alt: "Everlywell",
    src: logo,
    width: "107",
    height: "24"
  })), React.createElement(S.DesktopLinksWrapper, null, Object.entries(content).map(function (e, t) {
    return React.createElement(S.LinkSection, {
      key: "dt-link-section-" + t
    }, React.createElement(S.CategoryTitle, null, e[0]), React.createElement("ul", null, Object.entries(e[1]).map(function (e, t) {
      return React.createElement(S.CategoryListItem, {
        key: "footer-link-" + t
      }, React.createElement(S.FooterLink, {
        href: e[1]
      }, e[0]));
    })));
  })), React.createElement(S.SubscribeAndSocialSection, null, React.createElement(S.SubscribeHeading, null, "Subscribe to our newsletter"), React.createElement(S.SubscribeDescription, null, "Get the latest updates of products and company updates"), React.createElement(S.SubscribeInputWrapper, null, React.createElement(SubscribeInput, {
    onSubscribeSubmit: e
  })), React.createElement(S.SocialIconsWrapper, null, React.createElement(S.IconWrapper, {
    "aria-label": "Facebook",
    href: socialLinks.Facebook,
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Icons.Facebook, null)), React.createElement(S.IconWrapper, {
    "aria-label": "Instagram",
    href: socialLinks.Instagram,
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Icons.Instagram, null)), React.createElement(S.IconWrapper, {
    "aria-label": "Twitter",
    href: socialLinks.Twitter,
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Icons.Twitter, null)), React.createElement(S.IconWrapper, {
    "aria-label": "LinkedIn",
    href: socialLinks.LinkedIn,
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Icons.LinkedIn, null)))))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(S.DisclaimerText, null, "Everlywell offers access to laboratory testing for wellness monitoring, informational and educational use. With the exception of certain diagnostic test panels, list available", " ", React.createElement("a", {
    href: "https://support.everlywell.com/article/365-what-diagnostic-tests-does-everlywell-offer?_ga=2.16404342.156311377.1610383825-325840488.1607986328"
  }, "here"), ", the tests we offer access to are not intended to diagnose or treat disease. None of our tests are intended to be a substitute for seeking professional medical advice, help, diagnosis, or treatment. For regulatory reasons, our tests are not available in NY with the exception of COVID-19."))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(S.LegalSectionWrapper, null, React.createElement(S.LegalText, null, "© ", new Date().getFullYear(), " Everlywell, Inc. All rights reserved."), React.createElement(S.LegalLinkList, null, Object.entries(legalLinks).map(function (e, t) {
    return React.createElement(S.ListItem, {
      key: "dt-legal-li-" + t
    }, e[1].includes("accessibility") ? React.createElement(S.LegalLink, {
      "aria-label": "Click to view our Accessibility Statement or contact us with accessibility-related questions",
      href: e[1]
    }, e[0]) : React.createElement(S.LegalLink, {
      href: e[1]
    }, e[0]));
  })))))));
};
export default Footer;